import { NumberUtil } from '@/utils/NumbersUtil'
import StringMask from '@/utils/StringMask'
import { Validations } from '@/utils/Validations'
import Vue, { h } from 'vue'
import { VTextField } from 'vuetify/lib/components'

import './InputBase.scss'
import InputLabel from './InputLabel'
import { DateTime } from 'luxon'

const DATE_LENGTH = 8
const DATE_MASK = '00/00/0000'

export const InputBasico = Vue.extend({
	extends: VTextField,
	name: 'InputBasico',
	props: {
		outlined: { default: true },
		dense: { default: true },
		validateOnBlur: { default: true },
		autocomplete: { default: 'off' },
		label: { default: '', type: String },
		hint: { default: '', type: String },
		required: { default: false, type: Boolean },
		instructions: { default: '', type: String },
		persistentPlaceholder: { default: true },
		mask: { default: '', type: String },
		noRequiredText: { type: Boolean, default: false }
	},

	data: () => ({
		definedRules: new Array<any>(),
		isLoading: false
	}),

	computed: {
		computedProps(): Object {
			let props = {
				...this.$props,
				hint: '',
				rules: [this.isRequired ? Validations.isRequired : () => true, ...this.$props.rules, ...this.definedRules],
				label: '',
				validateOnBlur: true
			}

			return props
		},

		isRequired(): boolean {
			if (this.required) return true
			if (this.$props.rules) return this.$props.rules.includes(Validations.isRequired)

			return false
		},

		fieldName(): string {
			if ('name' in this.$props) return this.$props['name']

			return ''
		}
	},

	methods: {
		setRules(rules: Function[], propsRef: any) {
			rules = [...rules, this.isRequired ? Validations.isRequired : () => true]

			if (propsRef)
				//@ts-ignore
				rules.forEach((rule: Function) => propsRef.rules.push(rule))
			//@ts-ignore
			this.definedRules = rules
		},

		renderLabel() {
			if (!this.label || this.label == undefined) return <span />
			return (
				<InputLabel
					label={this.label}
					required={this.isRequired}
					instructions={this.instructions}
					hint={this.hint}
					noRequiredText={this.noRequiredText}
				/>
			)
		},

		maskedValue(value: string, maskFormat: string, maskedValue = true) {
			const mask = new StringMask({ mask: maskFormat })
			const result = mask.apply(value)

			//@ts-ignore
			this.lazyValue = result.maskedValue

			this.$emit('input', maskedValue ? result.maskedValue : result.unmaskedValue)
			this.$emit('inputUnmasked', result.unmaskedValue)

			return this.lazyValue
		},

		setLoading(value: boolean) {
			this.isLoading = value
		},

		filterKey(event: KeyboardEvent) {
			if (!NumberUtil.isDigit(event.key)) event.preventDefault()
		},

		handleInput(value: string) {
			const dateParsed = DateTime.fromISO(this.value)
			if (value && value.length > DATE_LENGTH && this.mask === DATE_MASK && dateParsed.isValid) {
				value = dateParsed.toFormat('dd/MM/yyyy')
			}
			if (this.mask) return this.maskedValue(value, this.mask)

			this.$emit('input', value)
		},

		renderInput() {
			const listeners = Object.assign(this.listeners$, { input: this.handleInput }) as any
			const attrs = {
				...this.$attrs
			}

			//@ts-ignore
			if (this.mask) attrs['maxLength'] = this.mask.length
			if (this.mask.includes('0')) listeners['keypress'] = this.filterKey

			return (
				<VTextField
					loading={this.isLoading}
					ref="input-internal-basic"
					{...{ props: this.computedProps, attrs: attrs, on: listeners }}
					v-model={this.internalValue}
					hidden-details={this.hiddenDetails}
					class="my-2"
				/>
			)
		}
	},

	watch: {
		loading: {
			handler(value: boolean) {
				this.isLoading = value
			}
		},
		internalValue: {
			handler(value: string) {
				if (!value) return

				this.handleInput(value)
			}
		}
	},

	render() {
		return h(
			'div',
			{
				class: 'd-flex flex-column app--input-base_wrapper'
			},
			[this.renderLabel(), this.renderInput()]
		)
	}
})

export default InputBasico
